import { render } from "./profileUser.vue?vue&type=template&id=9b2408fe&scoped=true"
import script from "./profileUser.vue?vue&type=script&lang=js"
export * from "./profileUser.vue?vue&type=script&lang=js"

import "./profileUser.vue?vue&type=style&index=0&id=9b2408fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b2408fe"]])

export default __exports__